import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const socialProofData = [{
  name: 'Valentina',
  city: 'Buenos Aires',
  time: '2 min'
}, {
  name: 'Diego',
  city: 'Rosario',
  time: '5 min'
}, {
  name: 'Sofía',
  city: 'CABA',
  time: '1 min'
}, {
  name: 'Martín',
  city: 'Córdoba',
  time: '8 min'
}, {
  name: 'Camila',
  city: 'Medellín',
  time: '3 min'
}, {
  name: 'Lucía',
  city: 'Santiago',
  time: '6 min'
}, {
  name: 'Rodrigo',
  city: 'Montevideo',
  time: '4 min'
}, {
  name: 'Ana',
  city: 'Bogotá',
  time: '7 min'
}, {
  name: 'Florencia',
  city: 'Mendoza',
  time: '2 min'
}, {
  name: 'Matías',
  city: 'La Plata',
  time: '9 min'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // Wait 20 seconds before showing the next one
      const timer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % socialProofData.length);
        setIsVisible(true);
      }, 20000);
      return () => clearTimeout(timer);
    } else {
      // Hide after 4 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  const currentData = socialProofData[currentIndex];
  return <AnimatePresence data-id="element-167">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-6 left-6 z-50 bg-card border-l-4 border-accent-gold rounded-xl shadow-2xl p-4 max-w-[280px] pr-8" data-id="element-168">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-text-secondary hover:text-white transition-colors" data-id="element-169">
            <XIcon className="w-4 h-4" data-id="element-170" />
          </button>

          <div className="flex items-center" data-id="element-171">
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-accent-gold font-bold shrink-0 mr-3" data-id="element-172">
              {currentData.name.charAt(0)}
            </div>
            <div data-id="element-173">
              <p className="text-white text-sm font-bold leading-tight" data-id="element-174">
                ⚡ {currentData.name} de {currentData.city}
              </p>
              <p className="text-accent-teal text-xs mt-0.5" data-id="element-175">
                acaba de obtener el pack
              </p>
              <p className="text-text-secondary text-[10px] mt-1" data-id="element-176">
                Hace {currentData.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}